import { useContext } from 'react';
import { AppStoreContext } from '../../stores/AppStore';

export const useAppStore = () => useContext(AppStoreContext);
